import { ACTIVATE_STAFF_URL, ADD_STAFF_URL, APPROVE_STAFF_URL, DEACTIVATE_STAFF_URL, EDIT_STAFF_URL, REJECT_STAFF_URL, RESET_STAFF_PASSWORD_URL, STAFF_LIST_URL, UNBLOCK_STAFF_URL, VIEW_STAFF_URL } from "../../constant"
import { resourceRequest } from "../calls"

/* --------- STAFF --------- */
export function doFetchStaff (token, data) {
    return resourceRequest(token, STAFF_LIST_URL, data)
}

export function doAddStaff (token, data) {
    return resourceRequest(token, ADD_STAFF_URL, data)
}

export function doViewStaff (token, data) {
    return resourceRequest(token, VIEW_STAFF_URL, data)
}

export function doEditStaff (token, data) {
    return resourceRequest(token, EDIT_STAFF_URL, data)
}

export function doActivateStaff (token, data) {
    return resourceRequest(token, ACTIVATE_STAFF_URL, data)
}

export function doDeactivateStaff (token, data) {
    return resourceRequest(token, DEACTIVATE_STAFF_URL, data)
}

export function doApproveStaff (token, data) {
    return resourceRequest(token, APPROVE_STAFF_URL, data)
}

export function doRejectStaff (token, data) {
    return resourceRequest(token, REJECT_STAFF_URL, data)
}

export function doResetStaffPassword (token, data){
    return resourceRequest(token, RESET_STAFF_PASSWORD_URL, data)
}

export function doUnblockStaff (token, data){
    return resourceRequest(token, UNBLOCK_STAFF_URL, data)
}